import { Component, Fragment } from 'react'
import styled from 'styled-components'
import { Hidden } from '@leroy-merlin-br/backyard-react-ui'

import fetch from 'scripts/utils/fetch'

import ShareButtons from 'reactGarden/ShareButtons'

import { ContextVisibility } from 'reactShared/components/ContextVisibility'

import { Breadcrumb } from 'reactSite/Breadcrumb'

import Shell from './Shell'
import FamilyHeader from './FamilyHeader'

const ENDPOINT = '/api/boitata/v1'

const WrapperBreadcrumb = styled.div(
  ({ theme }) => `
    align-items: center;
    box-shadow: 0 .25rem .25rem -.125rem rgba(210, 210, 211, .5);
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 1.25rem .625rem;

    @media (min-width: ${theme.media.tablet}) {
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }

    @media (min-width: ${theme.media.laptop.md}) {
      margin: 0 auto;
      max-width: 80rem;
      padding: .5rem 0;
    }
  `
)

class FamilyPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      categoryId: null,
      headerInfo: null,
      shellLoader: true
    }
  }

  async componentDidMount () {
    const { categoryId } = this.props

    const headerInfo = await this.getResource(categoryId)

    this.setState({
      categoryId,
      headerInfo,
      shellLoader: false
    })
  }

  async getResource (categoryId, resource = '') {
    const endpoint = `${ENDPOINT}/categories/${categoryId}/${resource}`

    const result = await fetch(endpoint)

    return result.json()
  }

  render () {
    const { categoryId, headerInfo, shellLoader } = this.state

    return (
      <Fragment>
        {shellLoader && <Shell />}
        <div className="new-container-fluid neutral-background">
          <div className="new-container">
            <div className="breadcrumb-share-bar">
              {categoryId && (
                <WrapperBreadcrumb>
                  <Breadcrumb categoryId={categoryId} />
                  <ContextVisibility when={['ecommerce']}>
                    <Hidden untilKilo kilo>
                      <ShareButtons />
                    </Hidden>
                  </ContextVisibility>
                </WrapperBreadcrumb>
              )}
            </div>
            {headerInfo && <FamilyHeader {...headerInfo} />}
          </div>
        </div>
      </Fragment>
    )
  }
}

export default FamilyPage
